import React, { useRef, useState } from "react";
import styles from "../styles/Developers.module.css"; // Create a CSS module for this page
import developerImage from "../assets/dev.jpg";
import API from "../assets/merchant.svg";
import { Link } from "react-router-dom";

import Footer from "../components/Footer";
import Header from "../components/Header";

function Integrate() {
  const handleTelegramLogin = () => {
    window.open("http://t.me/arifochet");
  };
  const ApiPageRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What are the documents needed for Arifpay integration?",
      answer: `Three documents are required to start the integration with ArifPay:

1. Business Registration Certificate
2. Business License
3. VAT Certificate`,
    },
    {
      question: "What if we don't have a VAT certificate?",
      answer:
        "If you don't have a VAT certificate, please reach out to our sales or support team. Depending on your business model, we may offer alternative onboarding procedures.",
    },
    {
      question: "How long does it take to finalize and go live?",
      answer:
        "Typically, the process takes 1–2 business days after all required documents are submitted and integration is complete.",
    },
    {
      question: "What is the maximum transaction limit?",
      answer: `Maximum Transaction Limits:
- Per Transaction: 150,000 ETB
- Daily Limit: 300,000 ETB`,
    },
    {
      question: "What is the minimum transaction amount?",
      answer: "The minimum transaction amount is 10 ETB.",
    },
    {
      question: "Does Arifpay support international payments?",
      answer:
        "Yes, Arifpay supports international card payments, including Visa and MasterCard, enabling seamless cross-border transactions for Ethiopian merchants.",
    },
  ];

  return (
    <div>
      <Header />
      <div className={styles.container} style={{ marginBottom: "100px" }}>
        <header
          style={{
            backgroundColor: "black",
            color: "white",
            padding: "10px 20px",
            alignItems: "center",
          }}
        >
          Get the <span className={styles.greenText}>API Collection </span> for
          Arif Gateway
        </header>

        <section
          className={styles.hero}
          style={{ margin: 0, paddingLeft: "20px", paddingRight: "20px" }}
        >
          <h1 style={{ fontSize: "3.4em" }} className={styles.heroTitle}>
            Arifpay for Developers
          </h1>
          <p style={{ fontSize: "2em", color: "black" }}>
            Best API integration in Ethiopia for digital payments
          </p>
          <p style={{ fontSize: "1.2em" }} className={styles.heroDescription}>
            Welcome to the Arifpay Developer Hub - your gateway to seamless,
            secure, and
            <br />
            scalable FinTech integrations in Ethiopia. Whether you're building a payment
            solution,
            <br />
            embedding financial services, or automating transactions, our APIs
            and developer
            <br />
            resources are designed to help you innovate with ease.
          </p>
          <div className={styles.heroButtons}>
            {/* <button className={styles.primaryButton}>
              Jump to Integration <span className={styles.arrow}>→</span>
            </button> */}
            <a href="https://developer.arifpay.net">
              <button
                style={{
                  height: "50px",
                  paddingTop: "10px",
                  borderRadius: "10px",
                }}
                className={styles.documentationButton}
              >
                Read Documentation
              </button>
            </a>
          </div>
        </section>

        <section
          style={{
            marginTop: "20px",
            position: "relative",
            textAlign: "center",
          }}
          className={styles.illustrationSection}
        >
          <img
            src={developerImage}
            alt="Developer Devices"
            className={styles.developerImage}
          />
        </section>

        {/* FAQ */}
        <section
          className={styles.faqSection}
          // style={{ padding: "10px 10px" }}
        >
          <div
            className={`${styles.faqGrid}`}
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "30px",
              alignItems: "flex-start",
            }}
          >
            <div className={styles.faqLeft} style={{}}>
              <h5
                style={{
                  color: "darkgreen",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  fontSize: "1.7em",
                }}
              >
                FAQ
              </h5>
              <h2
                style={{
                  fontSize: "1.8em",
                  fontWeight: "700",
                  lineHeight: "1.4",
                  marginBottom: "15px",
                }}
              >
                Frequently asked questions
              </h2>
              <p
                className={styles.paragraph}
                style={{
                  color: "#555",
                  lineHeight: "1.6",
                  fontSize: "1.1em",
                  whiteSpace: "per-line",
                }}
              >
                Explore to learn more about how Arifpay can
                <br /> empower your business with its Payment solutions.
              </p>
            </div>

            <div className={styles.faqRight} style={{}}>
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    marginBottom: "10px",
                    border: "1px solid #ddd",
                  }}
                >
                  <div
                    className={`faq-question ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                    style={{
                      padding: "15px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontWeight: "bold",
                      borderBottom:
                        activeIndex === index ? "1px solid #ddd" : "none",
                    }}
                  >
                    <span>{faq.question}</span>
                    {activeIndex === index ? (
                      // Up arrow (when expanded)
                      <svg
                        width="24"
                        height="26"
                        viewBox="0 0 24 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.7961 18.8843C18.1369 19.1998 18.6631 19.1998 19.0039 18.8843L19.2956 18.6143C19.6755 18.2624 19.6755 17.6616 19.2956 17.3098L12.6039 11.1139C12.2631 10.7983 11.7369 10.7983 11.3961 11.1139L4.70441 17.3099C4.32445 17.6617 4.32445 18.2625 4.70442 18.6144L4.99607 18.8844C5.33686 19.1999 5.86312 19.1999 6.2039 18.8844L12 13.5177L17.7961 18.8843Z"
                          fill="#656B61"
                        />
                      </svg>
                    ) : (
                      // Down arrow (when collapsed)
                      <svg
                        width="24"
                        height="26"
                        viewBox="0 0 24 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.2039 7.1157C5.86312 6.80015 5.33686 6.80015 4.99607 7.1157L4.70442 7.38565C4.32445 7.73753 4.32445 8.33834 4.70441 8.69021L11.3961 14.8861C11.7369 15.2017 12.2631 15.2017 12.6039 14.8861L19.2956 8.69015C19.6755 8.33827 19.6755 7.73746 19.2956 7.38558L19.0039 7.11563C18.6631 6.80008 18.1369 6.80008 17.7961 7.11563L12 12.4823L6.2039 7.1157Z"
                          fill="#656B61"
                        />
                      </svg>
                    )}
                  </div>
                  {activeIndex === index && (
                    <div
                      className="faq-answer"
                      style={{
                        padding: "15px",
                        color: "#555",
                        lineHeight: "1.6",
                      }}
                    >
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        <div
          className={styles.bottom}
          style={{
            backgroundColor: "black",
            color: "#fff",
            borderRadius: "35px",
            marginBottom: "20px",
            marginTop: "20px",
            paddingBottom: "0",
            paddingTop: "0",
            marginLeft: "50px",
            marginRight: "50px",
          }}
        >
          <div
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div
              className={styles.developerCommunity}
              style={{ flex: "1 1 300px", marginBottom: "8px" }}
            >
              <h2
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "120px",
                }}
              >
                Join the Arifoch Developer Community
              </h2>
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                  alignItems: "center",
                  marginLeft: "120px",
                }}
              >
                Connect with fellow developers, get support, and collaborate on
                open-source projects.
              </p>

              <div className={styles.heroButtons}>
                <button
                  onClick={handleTelegramLogin}
                  className={styles.primaryButton}
                >
                  Join our Telegram Group{" "}
                  <svg
                    className={styles.arrow}
                    width="10"
                    height="10"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.3787 17.0355C10.1392 16.9217 9.86081 16.9217 9.62134 17.0355L4.47635 19.4802C3.82468 19.7898 3.09663 19.2285 3.23581 18.5237L4.2851 13.2104C4.34063 12.9292 4.25392 12.6388 4.05306 12.4333L0.24956 8.54179C-0.25572 8.02483 0.0507134 7.15606 0.770008 7.06628L6.09202 6.40199C6.38352 6.36561 6.63742 6.1867 6.76858 5.92527L9.21406 1.0509C9.5375 0.406209 10.4625 0.40621 10.7859 1.0509L13.2314 5.92527C13.3626 6.1867 13.6165 6.36561 13.908 6.40199L19.23 7.06628C19.9493 7.15606 20.2557 8.02483 19.7504 8.54179L15.9469 12.4333C15.7461 12.6388 15.6594 12.9292 15.7149 13.2104L16.7642 18.5237C16.9034 19.2285 16.1753 19.7898 15.5237 19.4802L10.3787 17.0355Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {/* <button
                  style={{
                    height: "40px",
                    paddingTop: "10px",
                    borderRadius: "15px",
                  }}
                  className={styles.documentationButton}
                >
                  Contact our Developer Support
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Integrate;
